import { create } from "zustand";

import axios from 'axios';
import { ToastContainer } from 'react-toastify';
import { toast } from 'react-toastify';
import { notification } from "antd";
import { baseURL, baseURLWithoutApi } from "../../baseUrl";

export const useAgents = create((set, get) => ({
    loader: false,
    allAgentsResult: [],
    allAgentsPagination: {},
    actions: {
        editRealStateAgent: async (id, mobile, firstName, lastName, searchQuery, userId, stateId, cityId, areaId, page) => {

            console.log("editRealStateAgent called with params:", { id, mobile, firstName, lastName, stateId, cityId, areaId }); // debug
            // set((state) => ({ loader: true }))
            // await axios.post('https://api.pelakeman.com/api/RealEstateAgent/EditRealEstateAgent', {
            //     "id": id,
            //     "mobile": mobile,
            //     "firstName": firstName,
            //     "lastName": lastName,
            //     "searchQuery": searchQuery,
            //     "receiveSms": true,
            //     "userId": userId,
            //     "stateId": stateId,
            //     "cityId": cityId,
            //     "areaId": areaId,
            //     "page": page,
            // }, {
            //     headers: {
            //         "accept": "text/plain",
            //         "Content-Type": "application/json",
            //         Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
            //     },
            // })
            //     .then((res) => {

            //         set((state) => ({ loader: false }))
            //         console.log("editRealStateAgent: ", res);
            //         return res.data; // ✅ response data را return کنید
            //     }).catch((error) => {
            //         console.log("editRealStateAgent: ", error);
                    
            //         set((state) => ({ loader: false }))
            //         set((state) => ({ showServerError: true }))
            //         throw error; // یا می‌تونید null return کنید
            //     })
    console.log("🔥 editRealStateAgent function started"); // این باید نشان داده شود
    console.log("Parameters received:", { id, mobile, firstName, lastName });
    
    set((state) => ({ loader: true }))
    
    try {
        console.log("🔥 About to make axios call...");
        
        const axiosResponse = await axios.post(`${baseURL}/RealEstateAgent/EditRealEstateAgent`, {
            "id": id,
            "mobile": mobile,
            "firstName": firstName,
            "lastName": lastName,
            "searchQuery": searchQuery,
            "receiveSms": true,
            "userId": userId,
            "stateId": stateId,
            "cityId": cityId,
            "areaId": areaId,
            "page": page,
        }, {
            headers: {
                "accept": "text/plain",
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
            },
        });
        
        console.log("🔥 Axios response received:", axiosResponse);
        console.log("🔥 Axios response.data:", axiosResponse.data);
        console.log("🔥 About to return:", axiosResponse.data);
        
        set((state) => ({ loader: false }));
        const result = axiosResponse.data;
        
        console.log("🔥 Final result before return:", result);
        return result;
        
    } catch (error) {
        console.log("🔥 Error occurred:", error);
        set((state) => ({ loader: false }));
        set((state) => ({ showServerError: true }));
        
        console.log("🔥 About to return null due to error");
        return error.response.data;
    }
        },

        getAllAgents: async (id, mobile, firstName, lastName, searchQuery, userId, stateId, cityId, areaId, areaArray, page, isDeleted) => {
            set((state) => ({ loader: true }))
            // console.log({id, mobile, firstName, lastName, searchQuery, userId, stateId, cityId, areaId, areaArray, page, isDeleted});
            
            await axios.post(`${baseURL}/RealEstateAgent/getAllRealEstateAgent`, {

                "id": id,
                "mobile": mobile,
                "firstName": firstName,
                "lastName": lastName,
                "searchQuery": searchQuery,
                "userId": userId,
                "stateId": stateId,
                "cityId": cityId,
                "areaId": areaId,
                "areasArray": areaArray,
                "page": page,
                "isDeleted": isDeleted,

            }, {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {

                    set((state) => ({ loader: false }))
                    set((state) => ({ allAgentsResult: res.data.result }))
                    set((state) => ({ allAgentsPagination: res.data.pagination }))
                }).catch(() => {
                    set((state) => ({ loader: false }))
                    set((state) => ({ showServerError: true }))
                })
        },

        deleteAgent: async (id) => {
            
            await axios.post(`${baseURL}/RealEstateAgent/DeleteRealEstateAgent`,
                 {"realEstateAgentId": id},
                 {
                headers: {
                    "accept": "text/plain",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("pelakToken")}`
                },
            })
                .then((res) => {
                    console.log(res.data, "res.data in getAllAgents");
                 
                }).catch(() => {
                    
                    set((state) => ({ showServerError: true }))
                })
        },
    }
}))